// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__viewDrf___GtsfM {
  width: 100%;
}

.styles__cardMarginBot___X6hZR {
  /* position: relative; */
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
}
.styles__cardMarginBotWrapper___IGLiC {
  padding: 2rem 3.5rem;
  background-color: white;
}
.styles__cardMarginBotWrapperBottom___snfhM {
  padding: 0 3.5rem 2rem 3.5rem;
  background-color: white;
}

.styles__sectionNoMargin___k8EBo {
  padding: 0;
}

.styles__sectionNoMargin___k8EBo h2 {
    margin-bottom: 20px;
  }

.styles__sectionWrapper___sHbXV {
  display: flex;
}

.styles__sectionWrapper___sHbXV .styles__subSection___WhhjS {
    display: flex;
    flex-direction: column;
  }

.styles__sectionWrapper___sHbXV .styles__subSectionRight___mnQIq {
    align-items: flex-end;
  }
.styles__invoiceRightView___q3yva {
  display: flex;
  width: 280px;
  flex-direction: column;
}
.styles__subSection___WhhjS .styles__subSectionLabel___UULpa {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
.styles__subSection___WhhjS .styles__subSectionValue___uL9pu {
    color: #3b3b3b !important;
    font-size: 15px;
    font-weight: 400;
    margin-top: 0;
    opacity: 0.9;
  }

.styles__actionButton___qN_hP {
  display: flex;
  height: 50px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  box-shadow: none;
  padding-right: 16px;
  border-bottom: 1px solid borderColor;
}

.styles__actionButton___qN_hP:hover {
    box-shadow: none;
    background: #f8f8f8;
    cursor: pointer;
    -webkit-text-decoration: underline;
    text-decoration: underline;
  }

.styles__editButton___tjbU9 {
}

.styles__editButton___tjbU9::before {
    content: '';
    height: 100%;
    width: 36px;
    margin-bottom: 6px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px;
  }

.styles__payTo___dX8f0 {
  padding-top: 10px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.styles__payTo___dX8f0 .styles__payToAddress___nOnWr {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 15px;
    font-weight: 400;
    margin-top: 0;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    opacity: 0.9;
    gap: 2px;
  }

.styles__payTo___dX8f0 .styles__name___oe7hb {
  font-weight: bold;
  padding-right: 10px;
}

.styles__header___n9Jlb {
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]};
}

.styles__header___n9Jlb p {
    font-weight: 600 !important;
    margin-bottom: 4px;
  }
.styles__invoiceBottom___OR_2L {
  display: flex;
}
.styles__invoiceBottom___OR_2L p {
    font-weight: 400;
  }
.styles__invoiceBottom___OR_2L .styles__desc___u3ASe {
    width: calc(99.9% * 45/100 - (30px - 30px * 45/100));
    font-size: 15px;
  }
.styles__invoiceBottom___OR_2L .styles__desc___u3ASe:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }
.styles__invoiceBottom___OR_2L .styles__desc___u3ASe:last-child {
    margin-right: 0;
  }
.styles__invoiceBottom___OR_2L .styles__desc___u3ASe:nth-child(100n) {
    margin-right: 0;
    float: right;
  }
.styles__invoiceBottom___OR_2L .styles__desc___u3ASe:nth-child(100n + 1) {
    clear: both;
  }
.styles__invoiceBottom___OR_2L .styles__req___vvtck {
    width: calc(99.9% * 16/100 - (30px - 30px * 16/100));
    font-size: 15px;
  }
.styles__invoiceBottom___OR_2L .styles__req___vvtck:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }
.styles__invoiceBottom___OR_2L .styles__req___vvtck:last-child {
    margin-right: 0;
  }
.styles__invoiceBottom___OR_2L .styles__req___vvtck:nth-child(100n) {
    margin-right: 0;
    float: right;
  }
.styles__invoiceBottom___OR_2L .styles__req___vvtck:nth-child(100n + 1) {
    clear: both;
  }
.styles__invoiceBottom___OR_2L .styles__pay___oHB0S {
    width: calc(99.9% * 22/100 - (30px - 30px * 22/100));
    font-size: 15px;
  }
.styles__invoiceBottom___OR_2L .styles__pay___oHB0S:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }
.styles__invoiceBottom___OR_2L .styles__pay___oHB0S:last-child {
    margin-right: 0;
  }
.styles__invoiceBottom___OR_2L .styles__pay___oHB0S:nth-child(100n) {
    margin-right: 0;
    float: right;
  }
.styles__invoiceBottom___OR_2L .styles__pay___oHB0S:nth-child(100n + 1) {
    clear: both;
  }
.styles__invoiceBottom___OR_2L .styles__amt___numNr {
    width: calc(99.9% * 17/100 - (30px - 30px * 17/100));
    display: flex;
    align-items: start;
    justify-content: flex-end;
    font-size: 15px;
  }
.styles__invoiceBottom___OR_2L .styles__amt___numNr:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }
.styles__invoiceBottom___OR_2L .styles__amt___numNr:last-child {
    margin-right: 0;
  }
.styles__invoiceBottom___OR_2L .styles__amt___numNr:nth-child(100n) {
    margin-right: 0;
    float: right;
  }
.styles__invoiceBottom___OR_2L .styles__amt___numNr:nth-child(100n + 1) {
    clear: both;
  }

.styles__recurringInfo___QnSBE {
  display: flex;
  width: 100%;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleDark"]};
  font-weight: 700;
  font-style: italic;
  background: white;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  margin-top: 12px;
  font-size: 16px;
}

.styles__amountInfo___R05I3 {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-style: italic;
  background: white;
  justify-content: flex-end;
  margin-bottom: 0;
}

.styles__formPaymentTypeSubtitle___X2Saa {
  font-size: 14px;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/Main/view/styles.css"],"names":[],"mappings":"AAIA;EACE,WAAW;AACb;;AAEA;EAEE,wBAAwB;EACxB,8DAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EAEE,UAAU;AAIZ;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,aAAa;AAUf;;AARE;IACE,aAAa;IACb,sBAAsB;EACxB;;AAEA;IACE,qBAAqB;EACvB;AAEF;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AAEE;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;AACA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;EACd;;AAGF;EACE,aAAa;EACb,YAAY;EACZ,mDAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AAQtC;;AANE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kCAA0B;IAA1B,0BAA0B;EAC5B;;AAGF;AAaA;;AAVE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yDAAiD;IACjD,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;EACvB;;AAGF;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AAaV;;AAZE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mDAAW;IACX,YAAY;IACZ,QAAQ;EACV;;AAGF;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qEAAkC;AAKpC;;AAJE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;AAEF;EACE,aAAa;AAyBf;AAvBE;IACE,gBAAgB;EAClB;AAEA;IACE,oDAAqB;IACrB,eAAe;EACjB;AAHA;IACE,WAAqB;IAArB,kBAAqB;IAArB,WAAqB;EAEvB;AAHA;IACE,eAAqB;EAEvB;AAHA;IACE,eAAqB;IAArB,YAAqB;EAEvB;AAHA;IACE,WAAqB;EAEvB;AACA;IACE,oDAAqB;IACrB,eAAe;EACjB;AAHA;IACE,WAAqB;IAArB,kBAAqB;IAArB,WAAqB;EAEvB;AAHA;IACE,eAAqB;EAEvB;AAHA;IACE,eAAqB;IAArB,YAAqB;EAEvB;AAHA;IACE,WAAqB;EAEvB;AACA;IACE,oDAAqB;IACrB,eAAe;EACjB;AAHA;IACE,WAAqB;IAArB,kBAAqB;IAArB,WAAqB;EAEvB;AAHA;IACE,eAAqB;EAEvB;AAHA;IACE,eAAqB;IAArB,YAAqB;EAEvB;AAHA;IACE,WAAqB;EAEvB;AACA;IACE,oDAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;AANA;IACE,WAAqB;IAArB,kBAAqB;IAArB,WAAqB;EAKvB;AANA;IACE,eAAqB;EAKvB;AANA;IACE,eAAqB;IAArB,YAAqB;EAKvB;AANA;IACE,WAAqB;EAKvB;;AAGF;EACE,aAAa;EACb,WAAW;EACX,mDAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtCardHeaderBG, text, gtGrayMid, gtPurpleDark from colors;\n\n.viewDrf {\n  width: 100%;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n  /* position: relative; */\n  background-color: gtCardHeaderBG;\n}\n.cardMarginBotWrapper {\n  padding: 2rem 3.5rem;\n  background-color: white;\n}\n.cardMarginBotWrapperBottom {\n  padding: 0 3.5rem 2rem 3.5rem;\n  background-color: white;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n  padding: 0;\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.sectionWrapper {\n  display: flex;\n\n  .subSection {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .subSectionRight {\n    align-items: flex-end;\n  }\n}\n.invoiceRightView {\n  display: flex;\n  width: 280px;\n  flex-direction: column;\n}\n.subSection {\n  .subSectionLabel {\n    font-size: 15px;\n    font-weight: 600;\n    margin-bottom: 0.25rem;\n  }\n  .subSectionValue {\n    color: #3b3b3b !important;\n    font-size: 15px;\n    font-weight: 400;\n    margin-top: 0;\n    opacity: 0.9;\n  }\n}\n\n.actionButton {\n  display: flex;\n  height: 50px;\n  color: text;\n  font-weight: 600;\n  justify-content: flex-start;\n  align-items: center;\n  box-shadow: none;\n  padding-right: 16px;\n  border-bottom: 1px solid borderColor;\n\n  &:hover {\n    box-shadow: none;\n    background: #f8f8f8;\n    cursor: pointer;\n    text-decoration: underline;\n  }\n}\n\n.editButton {\n  composes: actionButton;\n\n  &::before {\n    content: '';\n    height: 100%;\n    width: 36px;\n    margin-bottom: 6px;\n    background-image: url('styles/img/icon_edit.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n  }\n}\n\n.payTo {\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  .payToAddress {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    font-size: 15px;\n    font-weight: 400;\n    margin-top: 0;\n    color: text;\n    opacity: 0.9;\n    gap: 2px;\n  }\n}\n\n.payTo .name {\n  font-weight: bold;\n  padding-right: 10px;\n}\n\n.header {\n  border-bottom: 1px solid gtGrayMid;\n  p {\n    font-weight: 600 !important;\n    margin-bottom: 4px;\n  }\n}\n.invoiceBottom {\n  display: flex;\n\n  p {\n    font-weight: 400;\n  }\n\n  .desc {\n    lost-column: 45 / 100;\n    font-size: 15px;\n  }\n  .req {\n    lost-column: 16 / 100;\n    font-size: 15px;\n  }\n  .pay {\n    lost-column: 22 / 100;\n    font-size: 15px;\n  }\n  .amt {\n    lost-column: 17 / 100;\n    display: flex;\n    align-items: start;\n    justify-content: flex-end;\n    font-size: 15px;\n  }\n}\n\n.recurringInfo {\n  display: flex;\n  width: 100%;\n  color: gtPurpleDark;\n  font-weight: 700;\n  font-style: italic;\n  background: white;\n  align-items: center;\n  gap: 6px;\n  justify-content: flex-end;\n  margin-top: 12px;\n  font-size: 16px;\n}\n\n.amountInfo {\n  display: flex;\n  width: 100%;\n  font-weight: 700;\n  font-style: italic;\n  background: white;\n  justify-content: flex-end;\n  margin-bottom: 0;\n}\n\n.formPaymentTypeSubtitle {\n  font-size: 14px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"gtPurpleDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtPurpleDark"]}`,
	"viewDrf": `styles__viewDrf___GtsfM`,
	"cardMarginBot": `styles__cardMarginBot___X6hZR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"cardMarginBotWrapper": `styles__cardMarginBotWrapper___IGLiC`,
	"cardMarginBotWrapperBottom": `styles__cardMarginBotWrapperBottom___snfhM`,
	"sectionNoMargin": `styles__sectionNoMargin___k8EBo ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"sectionWrapper": `styles__sectionWrapper___sHbXV`,
	"subSection": `styles__subSection___WhhjS`,
	"subSectionRight": `styles__subSectionRight___mnQIq`,
	"invoiceRightView": `styles__invoiceRightView___q3yva`,
	"subSectionLabel": `styles__subSectionLabel___UULpa`,
	"subSectionValue": `styles__subSectionValue___uL9pu`,
	"actionButton": `styles__actionButton___qN_hP`,
	"editButton": `styles__editButton___tjbU9 styles__actionButton___qN_hP`,
	"payTo": `styles__payTo___dX8f0`,
	"payToAddress": `styles__payToAddress___nOnWr`,
	"name": `styles__name___oe7hb`,
	"header": `styles__header___n9Jlb`,
	"invoiceBottom": `styles__invoiceBottom___OR_2L`,
	"desc": `styles__desc___u3ASe`,
	"req": `styles__req___vvtck`,
	"pay": `styles__pay___oHB0S`,
	"amt": `styles__amt___numNr`,
	"recurringInfo": `styles__recurringInfo___QnSBE`,
	"amountInfo": `styles__amountInfo___R05I3`,
	"formPaymentTypeSubtitle": `styles__formPaymentTypeSubtitle___X2Saa`
};
export default ___CSS_LOADER_EXPORT___;
